import React from 'react'
import CheckIcon from '@mui/icons-material/Check'

interface ItemStatusProps {
    progress?: string
}

export function ItemStatus({progress}: ItemStatusProps) {
    if (!progress) return <CheckIcon color="success" fontSize="small" />

    switch (progress) {
        case 'q-delete':
            return <span style={{color: 'red'}}>queued</span>
        case 'q-add':
            return <span style={{color: '#2e7d32'}}>queued</span>
        case 'deleting':
            return <span style={{color: 'red'}}>deleting</span>
        default:
            return <span style={{color: '#2e7d32'}}>{progress}</span>
    }
}
